import { translations } from "@/constants/translations";
import { renderInnerHtml } from "@/helpers/dom";
import { useStore } from "@/store";
import { Stack, Text, Link } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React from "react";

export const WelcomeFooter = observer(() => {
  const { activeLanguage } = useStore();
  const language = translations.pages["welcome"][activeLanguage];

  return (
    <Stack spacing="4">
      <Text>{renderInnerHtml(language.nasal_spray_pure)}</Text>
      <Text>{renderInnerHtml(language.while_narcan)}</Text>
      <Text>
        {renderInnerHtml(language.please_consult_product)}
        <Link
          textDecoration="underline"
          href={language.please_consult_link}
          target="_blank"
        >
          {renderInnerHtml(language.please_consult_product_link_text)}
        </Link>
        {renderInnerHtml(language.please_consult_product2)}
      </Text>
      <Text mb="4">{renderInnerHtml(language.always_read)}</Text>
      <Text>
        {renderInnerHtml(language.to_learn_more.text_1)}
        <Link
          textDecoration="underline"
          href={language.narcan_link}
          target="_blank"
        >
          {renderInnerHtml(language.narcannasalspray)}
        </Link>
        {renderInnerHtml(language.to_learn_more.text_2)}
      </Text>
    </Stack>
  );
});
